import * as React from 'react';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Radio from 'antd/lib/radio';
import Avatar from 'antd/lib/avatar';
import Select from 'antd/lib/select';
import Badge from 'antd/lib/badge';
import Skeleton from 'antd/lib/skeleton';
import {FinessePhonePlugin} from 'one-comp-phone';

const {
    Option,
} = Select;

import {
    Value,
    Values,
    SingleValue,
} from 'one-ui-values';

import {
    CardNoData,
    Card
} from 'one-ui-card';

import {
    buildGearActionsMenu,
} from 'one-ui-gear/src/actions';

import {
    SourceCardProps,
} from './props';

export const SourceCard = (
    props: SourceCardProps
) => {
    const {
        title,
        type,
        source,
        gearActions = [],
        onSourceChange,
        onSourceTypeChange,
        skeleton,
    } = props;

    const {
        source_skeleton,
        subject_skeleton,
    } = skeleton;

    let patientvaluecount = 0, providervaluecount = 0;
    let radio_badge = <div></div>;
    if (source) {
        const sourcedata = source.values;
        sourcedata.forEach((countvalue: any) => {
            if ((countvalue?.typename) === "Patient") {
                patientvaluecount = patientvaluecount + 1;
            }
            if ((countvalue?.typename) === "Provider") {
                providervaluecount = providervaluecount + 1;
            }
        })
    }

    const checkfornote = (sourcearray: any, typearray: any) => {
        let ispatient = false;
        let isprovider = false;
        let resultvalue: string;
        let arr: any = sourcearray?.values?.map((value: any) => {
            if (typearray?.values?.length > 0) {
                if ((value?.typename) === (typearray?.values[0]?.label)) {
                    ispatient = true;
                }
                if ((value?.typename) === (typearray?.values[1]?.label)) {
                    isprovider = true;
                }
            }
        });

        if (arr && arr?.length > 0 && ispatient && isprovider) {
            if (typearray?.selected?.label === typearray?.values[0]?.label) {
                resultvalue = "There is also a Provider match!";
                radio_badge = (
                    <>
                        <Radio.Group size="small"
                            defaultValue={
                                type?.selected?.id
                            }
                            value={
                                type?.selected?.id
                            }
                            className="ant-radio-group--small">
                            <Radio.Button value={typearray?.values[0]?.id} key={typearray?.values[0]?.id}>{typearray?.values[0]?.label}</Radio.Button>
                            <Badge count={providervaluecount} className="radio_patientbadge">
                                <Radio.Button
                                    value={typearray?.values[1]?.id} key={typearray?.values[1]?.id} onChange={(value: any) => {
                                        if (onSourceTypeChange) {
                                            onSourceTypeChange(value.target.value);
                                        }
                                    }}>{typearray?.values[1]?.label}</Radio.Button>
                            </Badge>
                        </Radio.Group>
                    </>
                )
            } else {
                resultvalue = "There is also a Patient match!";
                radio_badge = (
                    <>
                        <Radio.Group size="small"
                            defaultValue={
                                type?.selected?.id
                            }
                            value={
                                type?.selected?.id
                            }
                            className="ant-radio-group--small">
                            <Badge count={patientvaluecount} className="radio_providerbadge" offset={[-75, 0]}>
                                <Radio.Button value={typearray?.values[0]?.id} key={typearray?.values[0]?.id} onChange={(valuedata: any) => {
                                    if (onSourceTypeChange) {
                                        onSourceTypeChange(valuedata.target.value);
                                    }
                                }}>{typearray?.values[0]?.label}</Radio.Button>
                            </Badge>
                            <Radio.Button value={typearray?.values[1]?.id} key={typearray?.values[1]?.id}>{typearray?.values[1]?.label}</Radio.Button>
                        </Radio.Group>
                    </>
                )
            }
        } else {
            resultvalue = "";
            radio_badge = (
                <>
                    <Radio.Group
                        size="small"
                        defaultValue={
                            type?.selected?.id
                        }
                        value={
                            type?.selected?.id
                        }
                        className="ant-radio-group--small"
                    >
                        {
                            type?.values?.map(({ label, id }) => (
                                <Radio.Button value={id} key={id} onChange={(changevalue: any) => {
                                    if (onSourceTypeChange) {
                                        onSourceTypeChange(changevalue.target.value);
                                    }
                                }}>
                                    {label}
                                </Radio.Button>
                            ))
                        }
                    </Radio.Group>
                </>
            )
        }
        return resultvalue;
    }

    const patient = (type?.selected?.id === '1') && (
        <Row type="flex" gutter={[16, 32]}>
            <Col span={4}>
                <Badge count={patientvaluecount} showZero>
                    <Avatar size="large">{source?.selected?.initials}</Avatar>
                </Badge>
            </Col>
            <Col span={20}>
                <Row type="flex" gutter={[40, 28]}>
                    <Col>
                        <Select
                            style={{ width: 240 }}
                            defaultValue={source?.selected?.id}
                            value={source?.selected?.id}
                            onSelect={(value: string) => {
                                if (onSourceChange) {
                                    onSourceChange(value);
                                }
                            }}
                        >
                            {
                                source?.values?.filter((value) => (value?.typename === type?.selected?.label)).map(({ id, firstname }) => (
                                    <Option value={id} key={id}>{firstname}</Option>
                                ))
                            }
                        </Select>
                    </Col>
                </Row>
                <Row type="flex" gutter={[40, 28]}>
                    <Col span={14}>
                        <Values>
                        <FinessePhonePlugin 
                          label='Contact Number'
                          phone={source?.selected?.contact}
                       />
                            <Value
                                label="Address"
                                value={source?.selected?.address}
                            />
                        </Values>
                    </Col>
                    <Col span={10}>
                        <Values>
                            <SingleValue value={source?.selected?.age} />
                            <Value label="DOB" value={source?.selected?.dob} />
                            <Value label="EMPI" value={source?.selected?.mrn} />
                        </Values>
                    </Col>
                </Row>
            </Col>
        </Row>
    );

    const provider = (type?.selected?.id === '2') && (
        <Row type="flex" gutter={[16, 32]}>
            <Col span={4}>
                <Badge count={providervaluecount} showZero>
                    <Avatar size="large">{source?.selected?.initials}</Avatar>
                </Badge>
            </Col>
            <Col span={20}>
                <Row type="flex" gutter={[40, 28]}>
                    <Col>
                        <Select
                            style={{ width: 240 }}
                            defaultValue={source?.selected?.id}
                            value={source?.selected?.id}
                            onSelect={(selectvalue: string) => {
                                if (onSourceChange) {
                                    onSourceChange(selectvalue);
                                }
                            }}
                        >
                            {
                                source?.values?.filter((value) => (value?.typename === type?.selected?.label)).map(({ id, firstname }) => (
                                    <Option value={id} key={id}>{firstname}</Option>
                                ))
                            }
                        </Select>
                    </Col>
                </Row>
                <Row type="flex" gutter={[40, 28]}>
                    <Col span={14}>
                        <Values>
                        <FinessePhonePlugin 
                          label='Contact Number'
                          phone={source?.selected?.contact}
                       />
                            <Value label="Caller Type" value={source?.selected?.subtypename} />
                            <Value label="Caller Location" value={source?.selected?.address} />
                        </Values>
                    </Col>
                </Row>
            </Col>
        </Row>
    );

    // set default screen on intital/reset screen
    let result = (
        <Row type="flex" gutter={[16, 32]}>
            <Col span={4}>
                <Badge>
                    <Avatar size="large">{source?.selected?.initials}</Avatar>
                </Badge>
            </Col>
            <Col span={20}>
                <Row type="flex" gutter={[40, 28]}>
                    <Col>
                        <Select
                            style={{ width: 240 }}
                            defaultValue={source?.selected?.id}
                            value={source?.selected?.id}
                            onSelect={(selectedvalue: string) => {
                                if (onSourceChange) {
                                    onSourceChange(selectedvalue);
                                }
                            }}
                        >
                            {
                                source?.values?.map(({ id, firstname }) => (
                                    <Option value={id} key={id}>{firstname}</Option>
                                ))
                            }
                        </Select>
                    </Col>
                </Row>
                <Row type="flex" gutter={[40, 28]}>
                    <Col span={14}>
                        <Values>
                        <FinessePhonePlugin 
                          label='Contact Number'
                          phone={source?.selected?.contact}
                       />
                            <Value
                                label="Address"
                                value={source?.selected?.address}
                            />
                        </Values>
                    </Col>
                    <Col span={10}>
                        <Values>
                            <SingleValue value={source?.selected?.age} />
                            <Value label="DOB" value={source?.selected?.dob} />
                            <Value label="EMPI" value={source?.selected?.mrn} />
                        </Values>
                    </Col>
                </Row>
            </Col>
        </Row>
    );

    //Check for No Data
    if (source?.values?.length == 0 && ('selected' in source) && source?.selected === undefined) {
        result = (
            <>
                <CardNoData />
            </>
        );

    } else if (type?.selected?.id === '1') {
        result = patient;
    } else if (type?.selected?.id === '2') {
        result = provider;
    }

    if ((source_skeleton && subject_skeleton) ||
        (source_skeleton && !subject_skeleton) ||
        (!source_skeleton && subject_skeleton)) {
        result = (<Skeleton avatar active paragraph={{ rows: 3 }} />);
    }

    return (
        <Card
            note={checkfornote(source, type)}
            title={title}
            // extended={(
            //     <Radio.Group
            //         size="small"
            //         defaultValue={
            //             type?.selected?.id
            //         }
            //         value={
            //             type?.selected?.id
            //         }
            //         className="ant-radio-group--small"
            //     >
            //         {
            //             type?.values?.map(({ label, id }) => (
            //                 <Radio.Button value={id} key={id} onChange={(value: any) => {
            //                     if (onSourceTypeChange) {
            //                         onSourceTypeChange(value.target.value);
            //                     }
            //                 }}>
            //                     {label}
            //                 </Radio.Button>
            //             ))
            //         }
            //     </Radio.Group>
            // )}
            extended={
                <div>{radio_badge}</div>
            }
            gearActions={
                buildGearActionsMenu(
                    gearActions,
                )
            }
            body={
                result
            }
        />
    );
};
